import React, { useRef } from "react";
import { Link } from "react-router";
import FB from '../../../assets/img/icons/icon-social-fb.svg';
import In from '../../../assets/img/icons/icon-social-in.svg';
import Tw from '../../../assets/img/icons/icon-social-tw.svg';
import Gr from '../../../assets/img/icons/icon-social-gr.svg';


const ExternalLinks = ({ url }) => {

  return (<div className="external_links" >
    <a href='https://www.facebook.com/elogiesiempidf/' target="_blank"><img src={FB} /></a>
    <a href='https://twitter.com/elogiesiemp' target="_blank"><img src={Tw} /></a>
    <a href='https://www.instagram.com/elogiesiemp/' target="_blank"><img src={Gr} /></a>
    <a href='https://www.linkedin.com/company/elogie-siemp/?originalSubdomain=fr' target="_blank"><img src={In} /></a>
   </div>
    );
};
export default ExternalLinks;
